export default __webpack_public_path__ + "static/media/bolsa-trabajo.720c80ed.svg";